module.exports = __webpack_public_path__ + "4a2c8297dd87e3dee6c7b3042b1cd1bd.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/charts/pinterest_2023_chart.png
// module id = 1718
// module chunks = 0